import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  icon: '⏱️',
  title: 'Ahorro de Tiempo Real',
  desc: 'Planificaciones y recursos listos para adaptar y usar en minutos.'
}, {
  icon: '👶',
  title: 'Actividades Listas por Sala y Edad',
  desc: 'Propuestas organizadas para 18 meses, 2 años y 3 años.'
}, {
  icon: '📋',
  title: 'Orden Docente Sostenible',
  desc: 'Todo organizado y accesible cuando más lo necesitás.'
}, {
  icon: '📝',
  title: 'Informes sin Bloqueo',
  desc: 'Modelos listos para completar en minutos, no en horas.'
}];
export function FeaturesSection() {
  return <section className="py-16 md:py-24 bg-white pt-[30px] pb-[30px]" data-id="element-40">
      <div className="container mx-auto px-4 max-w-[1100px]" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-[#1a2e5a]" data-id="element-43">
            ¿QUÉ VAS A LOGRAR CON ESTE SISTEMA?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-44">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex items-start gap-4 bg-[#f8f8f8] p-8 rounded-2xl border border-slate-100" data-id="element-45">
              <div className="text-4xl flex-shrink-0 mt-1" data-id="element-46">{feature.icon}</div>
              <div data-id="element-47">
                <h3 className="font-bold text-[#1a2e5a] mb-2 text-xl" data-id="element-48">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-lg" data-id="element-49">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}